import { Component} from '@angular/core';

@Component({
  selector: 'lib-for-upload-svg',
  templateUrl: './for-upload.component.svg'
})
export class ForUploadSvgComponent {
  
}

